module.exports = __webpack_public_path__ + "img/img5.e369b2c2.jpg";